import { render, staticRenderFns } from "./DashboardFidChartsData.vue?vue&type=template&id=021fb38c&"
import script from "./DashboardFidChartsData.vue?vue&type=script&lang=js&"
export * from "./DashboardFidChartsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports